import { createQueryKeys } from "@lukemorales/query-key-factory";
import { queryOptions } from "@tanstack/react-query";

import { usePaginateQuery } from "@/hooks";
import { api } from "@/lib/api";
import { type Paginate } from "@/types";

import { type Attribute } from "@/modules/recognition/user/types";

export type AttributeList = Paginate<Attribute>;

export const attrbiutes = createQueryKeys("recognition-attributes", {
  all: (valueId?: number, page?: number) => [{ valueId, page }],
});

const include = "";

export const fetchAttriutesQueryOptions = (
  valueId: number | undefined,
  page: number = 0,
) =>
  queryOptions({
    ...attrbiutes.all(valueId, page),
    queryFn: () =>
      api
        .get<AttributeList>(
          `/recognition/values/${valueId}/attributes?include=${include}`,
          {
            params: { page },
          },
        )
        .then((response) => response.data),
    enabled: valueId !== undefined,
  });

export const useFetchAttributes = (valueId?: number) =>
  usePaginateQuery((page) => fetchAttriutesQueryOptions(valueId, page));
